import { request } from '@ui/api/v2/api';

export enum UserRoleEnum {
  Manager = 'manager',
  ContentManager = 'contentManager',
  Admin = 'admin',
}

export interface IUser {
  firstName: string | null;
  id: number;
  idLotus: string;
  lastName: string | null;
  login: string;
  middleName: string | null;
  password: string;
  role: UserRoleEnum;
}

export type IContentManager = IUser;

export interface ICreateContentManager {
  firstName: string;
  idLotus: string;
  lastName: string;
  middleName: string;
  login: string;
  password: string;
}

export function getContentManagers() {
  return request<IContentManager[]>('get', 'user/content-managers');
}

export function createContentManager(data: ICreateContentManager) {
  return request<IContentManager>('post', 'user/content-manager', data);
}

export function updateContentManager(id: number, data: ICreateContentManager) {
  return request('patch', `user/content-manager/${id}`, data);
}

export function deleteContentManager(id: number) {
  return request('delete', `user/content-manager/${id}`);
}

export function removeManager(id: number) {
  return request('delete', `user/manager/${id}`);
}



// WEBPACK FOOTER //
// ./src/api/v2/user.api.ts